goog.module('yext.storm.PageNav');
goog.module.declareLegacyNamespace();

/**
 * Powers page navs like the quick nav in Location Edit
 * TODO(mattjs) Restore page scroll state properly
 *
 * @param {!jQuery} $nav Contains the page navigation
 * @param {!jQuery} $contents Contains the page contents being navigated
 * @constructor
 * @author MattJS (matt@yext.com)
 */
const PageNav = function($nav, $contents) {
  this.$nav = $nav;
  this.$contents = $contents;
  this.$breadcrumbs = $('#breadcrumbs');

  this.sections = [];
  this.fixedPositionThreshold = this.getFixedPositionThreshold();
  this.overScroll = 0;

  var self = this;
  /* $(function() {
    self.generateSections();
    self.bindScroll();
    self.render();
    self.bindGoogleAttributeToggle();
  });*/

  $(function() {
    self.bindScroll();
    self.render();
    self.bindBasicClick();
    if (window.location.hash) {
      self.scrollToSection(window.location.hash.slice(1));
    }
  });
};

/**
 * Basic version of the nav function
 */
PageNav.prototype.bindBasicClick = function() {
  var self = this;
  var $anchors = this.$nav.find('a');
  $anchors.click(function(e) {
    e.preventDefault();
    var id = $(this).attr('href').slice(1);
    self.scrollToSection(id);
    return false;
  });
};

/**
 * Scroll to the section with a given id
 * @param {string} id
 */
PageNav.prototype.scrollToSection = function(id) {
  this.$nav.find('a').removeClass('name-highlighted');
  this.$nav.find('a[href=\\#'+ id + ']').addClass('name-highlighted');

  var $section = $('#' + id);
  if ($section.length) {
    var section = $section.get(0);
    var top = section.offsetTop + (section.offsetParent ? section.offsetParent.offsetTop : 0);
    $('html, body').animate({
      scrollTop: (top - 41) + 'px',
    }, 500, 'easeOutQuad');
    if (window.history) {
      window.history.pushState(null, null, '#' + id);
    }
  }
};

// This shifts the scroll range up so that you enter a section slightly before entering the section
PageNav.RANGE_SHIFT = 30;

/**
 * Get the fraction of the page height used in calculating the pivot
 */
PageNav.prototype.getPageFraction = function() {
  return 0.95;
};

PageNav.prototype.getFixedPositionThreshold = function() {
  return this.$breadcrumbs.get(0).offsetTop;
};

/**
 * This provides space for things, ex. breadcrumbs, at the top of the page, plus some padding
 *
 * @return {number} A margin to offset the scrolling by
 */
PageNav.prototype.getTopMargin = function() {
  return this.$breadcrumbs.outerHeight();
};

/**
 * Top margin with additional padding to avoid elements butting up
 */
PageNav.prototype.getTopMarginWithPadding = function() {
  return this.getTopMargin() + 5;
};

/**
 * Loop through the DOM to generate sections
 */
PageNav.prototype.generateSections = function() {
  var self = this;
  this.$nav.find('a').each(function() {
    var section = new PageNav.Section($(this));
    if (section.$section.length) {
      self.bindSection(section);
      self.sections.push(section);
    }
  });
};

/**
 * Get the point where the scrolling will switch toward the end of the page scroll
 * @return {number}
 */
PageNav.prototype.getPivot = function() {
  return this.getMaxScrollTop() - ($(window).height() * this.getPageFraction());
};

/**
 * Bind the section selected event
 */
PageNav.prototype.bindSection = function(section) {
  var self = this;
  var $root = $('html, body');
  $(section).on('anchorSelected', function() {
    $root.animate({
      scrollTop: self.getScrollTop(section),
    }, 500, 'easeOutQuad');
    if (window.history) {
      window.history.pushState(null, null, '#' + section.id);
    }
  });
};

/**
 * Get the correct scroll top for a section
 * @return {number}
 */
PageNav.prototype.getScrollTop = function(section) {
  var maxScrollTop = this.getMaxScrollTop();
  if (section.getRange().top > maxScrollTop) {
    return maxScrollTop;
  } else {
    return section.getRange().top - this.getTopMarginWithPadding();
  }
};

/**
 * Render on page scroll
 */
PageNav.prototype.bindScroll = function() {
  var self = this;
  $(document).scroll(function() {
    self.render();
  });
};

/**
 * Sets fixed positioning and section selection when scrolling
 */
PageNav.prototype.render = function() {
  var scrollTop = this.getWindowScrollTop();
  // Toggle fixed position elements
  if (scrollTop >= this.fixedPositionThreshold) {
    this.setItemsFixed();
  } else {
    this.setItemsRelative();
  }
  // Navigation highlighting
  /* for (var i = 0; i < this.sections.length; i++) {
    var section = this.sections[i];
    if (this.inScrollRegion(section)) {
      section.setSelected();
    } else {
      section.clearSelected();
    }
  }*/
};

/**
 * Sets the items to fixed
 */
PageNav.prototype.setItemsFixed = function() {
  var topMargin = this.getTopMargin();
  this.$breadcrumbs.addClass('fixed-breadcrumbs');
  this.$nav.addClass('fixed-sidebar');
  this.$nav.css('height', ($(window).height() - topMargin) + 'px');
  // Deal with the breadcrumbs becoming fixed
  this.$contents.css('margin-top', topMargin + 'px');
};

/**
 * Sets the items to relative
 */
PageNav.prototype.setItemsRelative = function() {
  this.$breadcrumbs.removeClass('fixed-breadcrumbs');
  this.$nav.removeClass('fixed-sidebar');
  this.$nav.css('height', '');
  this.$contents.css('margin-top', 0);
  // Grab a new value each time we are relative again
  // this will help with any page resize before scrolling
  this.fixedPositionThreshold = this.getFixedPositionThreshold();
};

/**
 * Checks if the section has entered its scroll region
 *
 * @param {PageNav.Section} section
 * @return {boolean}
 */
PageNav.prototype.inScrollRegion = function(section) {
  var scrollTop = this.getWindowScrollTop();
  var pivot = this.getPivot();
  var target = scrollTop + this.getTopMarginWithPadding();
  var range = section.getRange();

  // Start moving the target or 'eye-line' when toward the end of the scrolling (> pivot)
  if (scrollTop > pivot) {
    target += (scrollTop - pivot);
    // Check if it is the last section and extend the range to the end of the page
    var index = this.sections.indexOf(section);
    if (index === this.sections.length - 1) {
      range.bottom = $('html, body').height() + 100;
    }
  } else {
    range = this.modifyRange(section);
  }

  return target >= range.top && target < range.bottom;
};

/**
 * Checks if the section has entered its scroll region
 *
 * @param {PageNav.Section} section
 * @return {boolean}
 */
PageNav.prototype.modifyRange = function(section) {
  var index = this.sections.indexOf(section);
  var range = section.getRange();

  if (index === 0) {
    range.top = 0;
  } else {
    range.top = Math.max(range.top - PageNav.RANGE_SHIFT, 0);
  }
  range.bottom = Math.max(range.bottom - PageNav.RANGE_SHIFT, 0);

  return range;
};

/**
 * Get the max scroll top the page can have
 * @return {number}
 */
PageNav.prototype.getMaxScrollTop = function() {
  var $window = $(window);
  var $root = $('html, body');
  return Math.max($root.height() - $window.height(), 0);
};

/**
 * Cross browser window scroll top calculation
 *
 * @return {number}
 */
PageNav.prototype.getWindowScrollTop = function() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};

/**
 * Toggles the GMB sidebar anchor to keep it in-sync with its section's visibility
 */
PageNav.prototype.bindGoogleAttributeToggle = function() {
  var gmbSection = this.getSection('section-gmb_attributes');
  if (gmbSection) {
    $(yext.location.events).on('googleAttributesChanged', function(e, toToggle) {
      gmbSection.$anchor.toggle(toToggle);
    });
  }
};

/**
 * @param {string} sectionId
 * @return {PageNav.Section}
 */
PageNav.prototype.getSection = function(sectionId) {
  for (var i = 0; i < this.sections.length; i++) {
    if (this.sections[i].id === sectionId) {
      return this.sections[i];
    }
  }
};

/**
 * @param {!jQuery} $anchor The sidebar <a> tag
 * @constructor
 */
PageNav.Section = function($anchor) {
  this.id = $anchor.attr('href').slice(1);

  this.$anchor = $anchor;
  this.$section = $('#' + this.id);

  // Currently all sections have sidebar links, some just hidden while the section can
  // be missing from the page
  // TODO(mattjs) Fix this
  if (!this.$section.length) {
    return;
  }

  this.bind();
};

/**
 * Binds the click and sends a custom event so that PageNav class can coordinate
 */
PageNav.Section.prototype.bind = function() {
  var self = this;
  this.$anchor.on('click', function(e) {
    e.preventDefault();
    self.message('anchorSelected');
    return false;
  });
};

/**
 * Trigger a message with the section instance as context
 * @param {string} message
 */
PageNav.Section.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Get the range on this page for which the section spans
 * @return {!Object}
 */
PageNav.Section.prototype.getRange = function() {
  var section = this.$section.get(0);
  var top = section.offsetTop + (section.offsetParent ? section.offsetParent.offsetTop : 0);
  return {
    top: top,
    bottom: top + this.getHeight(),
  };
};

/**
 * @return {number}
 */
PageNav.Section.prototype.getHeight = function() {
  return this.$section.outerHeight(true); // Include the bottom margin
};

/**
 * Sets the anchor selected class
 */
PageNav.Section.prototype.setSelected = function() {
  this.$anchor.addClass('name-highlighted');
};

/**
 * Removes the anchor selected class
 */
PageNav.Section.prototype.clearSelected = function() {
  this.$anchor.removeClass('name-highlighted');
};

goog.exportSymbol('yext.storm.PageNav', PageNav);

exports = PageNav;
